const householdSec3_Object = (payload) => {
  return {
    type: "householdSec3",
    payload,
  };
};

export default householdSec3_Object;
